<template>
	<div class="d-flex w-100 h-100">
		<h4 class="mx-auto text">{{ text }}</h4>
	</div>
</template>

<script>
export default {
	name: "TimelineText",
	props: {
		text: String,
	}
};
</script>

<style scoped>
	.text {
		font-family: 'Sarabun', serif;
		font-size: 20px;
		line-height: 34px;
		text-align: left;
		color: #fff;
	}
</style>